<template>
  <FlexCol>
    <h2>Stamp Card Setup</h2>
    <hr class="border-secondary" />
    <CardPage :brand-name="store.brandName" :is-onboarding="true" />
  </FlexCol>
</template>
<script setup>
import FlexCol from "@/components/layout/FlexCol.vue";
import CardPage from "@/pages/LoyaltyProgram/Stamp/CardAndReward/CardPage.vue";
import { useBrandSetupStore } from "@/stores/brand";

const store = useBrandSetupStore();
</script>
